export default __webpack_public_path__ + "static/media/icon_17.c05ac895.png";